<template>
    <v-container style="margin-top: 100px">
        <v-layout
                text-center
                wrap
                align-center justify-center
        >

            <v-flex xs12>
                <div class="display-1 ma-3">
                  {{ title }}
                </div>
            </v-flex>

            <v-flex xs12 sm8 md6 lg4 class="my-5">
                <div v-if="error">
                    <v-alert type="error">
                        {{ error }}
                    </v-alert>
                </div>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="E-Mail"
                            required
                    ></v-text-field>

                    <v-text-field
                            v-if="loginScreen"
                            v-model="password"
                            :rules="passwordRules"
                            label="Passwort"
                            required
                            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="passwordShow ? 'text' : 'password'"
                            @click:append="passwordShow = !passwordShow"
                            @keydown.enter="validate"
                    ></v-text-field>

                    <v-btn
                            block
                            color="primary"
                            @click="validate"
                            :disabled="loading || !valid"
                            :loading="loading"
                    >
                        {{loginButtonText}}
                    </v-btn>

                </v-form>

                <div class="ma-5">
                    <v-btn text x-small @click="loginScreen= !loginScreen">{{changeButtonText}}</v-btn>
                </div>
<!--                <div class="ma-5">-->
<!--                    <v-btn text x-small @click="onRegister">Register</v-btn>-->
<!--                </div>-->
            </v-flex>


        </v-layout>

    </v-container>
</template>

<script>
    export default {
        name: "Login",
        components: {
            // Navbar,
        },
        data: () => ({
            error: false,
            loading: false,
            loginScreen: true,
            passwordShow: false,
            valid: true,
            email: '',
            emailRules: [
                v => !!v || "E-mail is required",
                v =>
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-Mail is not valid'
            ],
            password: '',
            passwordRules: [
                v => !!v || "Password is required"
            ]
        }),
        computed: {
            title() {
                return this.loginScreen ? 'Login' : 'Reset Password';
            },
            loginButtonText() {
                return this.loginScreen ? 'Login' : 'Reset Password';
            },
            changeButtonText() {
                return this.loginScreen ?  'Forgot Password?' : 'Back to Login';
            },
        },
        watch: {
            title() {
                this.error = '';
            }
        },
        mounted() {
            //console.log('got router params: ', this.$route.params);
        },
        methods: {
            validate () {
                if (this.$refs.form.validate()) {
                    this.snackbar = true

                    if(this.loginScreen) {
                        this.onSigninEmail()
                    }
                    else {
                        this.recoverPassword()
                    }
                }
            },
            onRegister() {
                this.$router.push({ name: "Register" })
            },
            onSigninEmail () {
                this.loading = true;
                 var self = this;


                const user = {
                    email: this.email,
                    password: this.password
                }

                this.$store.dispatch('user/signUserIn', user)
                .then((user) => {
                     console.log(user);
                    this.$router.push({name: 'Admin'});
                })
                .catch((error) => {
                    alert(error);
                })
                .finally(() => {
                    self.loading = false;
                })


                // fb.auth.signInWithEmailAndPassword(this.email, this.password)
                //     .then(
                //         user => {
                //             // console.log(user)
                //             fb.auth.currentUser.getIdTokenResult()
                //                 .then(tokenResult => {
                //                     // console.log(tokenResult.claims);
                //                     this.$store.dispatch('setUserClaims', {user: user, roles: tokenResult.claims});
                //                 })
                //             .then(() => {
                //                 // console.log(user);
                //                 this.$router.push('/');
                //             })
                //         }
                //     )
                //     .catch(
                //         error => {
                //             this.error = error;
                //         }
                //     )
                //     .finally(() => {
                //             self.loading = false
                //         }
                //     )
            },
            recoverPassword() {

                this.loading = true;
                var self = this;

                this.$store.dispatch('recoverPassword', this.email)
                    .then((user) => {
                        console.log(user);
                        self.$confirm('Please follow the instructions in the email we sent you!', {buttonFalseText:false, buttonTrueText: 'Got it', persistent: true})
                    })
                    .catch((error) => {
                        self.$confirm(error, {buttonFalseText:false, buttonTrueText: 'Got it', persistent: true})
                    })
                    .finally(() => {
                                    self.loading = false
                                }

                            )}
        }
    }
</script>

<style scoped>

</style>